const THEME_STORAGE_KEY = 'seedkit-theme-state';

function applySeedkitThemeStateDarkClass() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle(
    'seedkit-theme-state--dark',
    localStorage.getItem(THEME_STORAGE_KEY) === 'dark',
  );
}

declare global {
  interface Window {
    __pokolenieSeedkitThemeDarkClassSync?: boolean;
  }
}

/**
 * Синхронизирует класс `seedkit-theme-state--dark` на `<html>` с `localStorage['seedkit-theme-state'] === 'dark'`
 * (как в плагине темы Seedkit). Нужен, чтобы в чистом CSS ограничить переопределения только этим режимом.
 */
export function initSeedkitThemeStateDarkClassSync() {
  applySeedkitThemeStateDarkClass();

  if (typeof window === 'undefined') return;

  if (!window.__pokolenieSeedkitThemeDarkClassSync) {
    window.__pokolenieSeedkitThemeDarkClassSync = true;

    window.addEventListener('storage', (e) => {
      if (e.key === THEME_STORAGE_KEY || e.key === null) applySeedkitThemeStateDarkClass();
    });

    const { setItem, removeItem, clear } = Storage.prototype;

    Storage.prototype.setItem = function (key: string, value: string) {
      setItem.call(this, key, value);
      if (key === THEME_STORAGE_KEY) applySeedkitThemeStateDarkClass();
    };

    Storage.prototype.removeItem = function (key: string) {
      removeItem.call(this, key);
      if (key === THEME_STORAGE_KEY) applySeedkitThemeStateDarkClass();
    };

    Storage.prototype.clear = function () {
      clear.call(this);
      applySeedkitThemeStateDarkClass();
    };
  }
}
